// extracted by mini-css-extract-plugin
export default {"copyRightFooter":"copyRightFooter_copyRightFooter__8H9b9","h4":"copyRightFooter_h4__SPYE1","h3":"copyRightFooter_h3__wD0Av","span":"copyRightFooter_span__95ADw"};